var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40592 8.95675C9.40592 9.58957 8.89291 10.1026 8.26009 10.1026C7.62727 10.1026 7.11426 9.58957 7.11426 8.95675C7.11426 8.32393 7.62727 7.81091 8.26009 7.81091C8.89291 7.81091 9.40592 8.32393 9.40592 8.95675Z",
    stroke: "#2E77D0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82267 8.95675C4.82267 9.58957 4.30966 10.1026 3.67684 10.1026C3.04401 10.1026 2.53101 9.58957 2.53101 8.95675C2.53101 8.32393 3.04401 7.81091 3.67684 7.81091C4.30966 7.81091 4.82267 8.32393 4.82267 8.95675Z",
    stroke: "#2E77D0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11442 8.95674H4.82275M9.40609 8.95674H9.75589C9.85668 8.95674 9.90709 8.95674 9.94944 8.95147C10.2617 8.91256 10.5077 8.66657 10.5467 8.35426C10.5519 8.31191 10.5519 8.2615 10.5519 8.16071V6.89424C10.5519 5.24889 9.21812 3.91507 7.57275 3.91507M7.34359 8.04007V4.14424C7.34359 3.49606 7.34359 3.17197 7.14224 2.97061C6.94085 2.76924 6.61676 2.76924 5.96859 2.76924H2.76025C2.11207 2.76924 1.78798 2.76924 1.58662 2.97061C1.38525 3.17197 1.38525 3.49606 1.38525 4.14424V7.81091C1.38525 8.23927 1.38525 8.45345 1.47736 8.61299C1.5377 8.71749 1.62449 8.8043 1.729 8.86462C1.88854 8.95674 2.10272 8.95674 2.53109 8.95674",
    stroke: "#2E77D0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.468506 0.935913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelType);
export default __webpack_public_path__ + "static/media/travelType.9f053d12b6ba7bfb4b4276042273082a.svg";
export { ForwardRef as ReactComponent };